import './style.scss';
import { SymbolDetailInfo, OverseasRealEstateSymbolDetailInfo } from 'views/utils/graphql/graphql';
import { DomesticRealEstateSymbolDetailInfo } from 'views/utils/graphql/graphql';

export const LeaseFundThumbnail = ({ Status, ImageUrl, SymbolShortName, SymbolType }: SymbolDetailInfo) => {
  return (
    <div className="leaseFund">
      <div className="thumbnail">
        <div className="thumbnail_tag">{LeaseFundGetStatusName(Status)}</div>
        <img src={ImageUrl} alt="" />
        <div className="thumbnail_title">{`${SymbolShortName}（${SymbolType}）`}</div>
      </div>
    </div>
  );
};

const LeaseFundGetStatusName = (status: number) => {
  switch (status) {
    case 1:
      return 'NEW';
    case 2:
      return '販売中';
    case 3:
      return '申込締切';
    case 4:
      return '完売';
  }
};

export const DomesticRealEstateThumbnail = ({ Status, ImageURL }: DomesticRealEstateSymbolDetailInfo) => {
  return (
    <div className="domesticRealEstate">
      <div className="thumbnail">
        <div className="thumbnail_tag">{DomesticRealEstateGetStatusName(Status!)}</div>
        <img src={ImageURL!} alt="" />
      </div>
    </div>
  );
};

const DomesticRealEstateGetStatusName = (status: number) => {
  switch (status) {
    case 1:
      return 'NEW';
    case 2:
      return '販売中';
    case 3:
      return '申込締切';
    case 4:
      return '完売';
  }
};

export const OverseasRealEstateThumbnail = ({
  Status,
  ImageUrl,
  SymbolShortName,
}: OverseasRealEstateSymbolDetailInfo) => {
  return (
    <div className="overseasRealEstate">
      <div className="thumbnail">
        <div className="thumbnail_tag">{OverseasRealEstateGetStatusName(Status)}</div>
        <img src={ImageUrl} alt="" />
      </div>
    </div>
  );
};

const OverseasRealEstateGetStatusName = (status: number) => {
  switch (status) {
    case 1:
      return 'NEW';
    case 2:
      return '販売中';
    case 3:
      return '申込締切';
    case 4:
      return '完売';
  }
};
